import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//
import Moment from "react-moment";
import ScrollBar from "react-perfect-scrollbar";
import { Card, InputGroup, FormControl, Tabs, Tab } from "react-bootstrap";

//
import NothingToShow from "../general/NothingToShow";
import BoxLoading from "../general/BoxLoading";

//
import { getTickets } from "../../redux/features/tickets/actions";

//
import User from "../../assets/img/user.png";

function TicketList({ selectedTicket, setSelectedTicket, mainCardHeight }) {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [activeTickets, setActiveTickets] = useState([]);
  const [deactiveTickets, setDeactiveTickets] = useState([]);

  /**
   * Get Ticket List
   */
  const get_ticket_list = async () => {
    // start loading
    setLoading(true);

    // request
    await getTickets().then((res) => {
      if (res) {
        setActiveTickets(res);
        let openTickets = [];
        let closeTickets = [];

        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          if (element.status === "close") {
            closeTickets.push(element);
          } else {
            openTickets.push(element);
          }
        }

        setActiveTickets(openTickets);
        setDeactiveTickets(closeTickets);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_ticket_list();

    // eslint-disable-next-line
  }, []);

  return (
    <Card>
      <Card.Header className="search no-border">
        <InputGroup className="w-100 me-0">
          <InputGroup.Text>
            <i className="las la-search"></i>
          </InputGroup.Text>
          <FormControl
            placeholder="Search message"
            className="ps-0"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      </Card.Header>
      <Card.Body className="message-content">
        <Tabs defaultActiveKey="1">
          {/* Active Messages */}
          <Tab eventKey="1" title="Active">
            {activeTickets.length ? (
              <ScrollBar style={{ height: `${mainCardHeight - 127}px` }}>
                {activeTickets.map((item) => (
                  <div className="item-box" key={item.id}>
                    <div
                      className={`item ${
                        selectedTicket && item.id === selectedTicket.id
                          ? "active"
                          : ""
                      }`}
                      key={item.id}
                      onClick={() => setSelectedTicket(item)}
                    >
                      <div>
                        <img
                          src={User}
                          alt="user-img"
                          className="rounded-full"
                        />
                        <div>
                          <small
                            className={
                              +item.total_message_unread
                                ? "text-black fw-bolder"
                                : ""
                            }
                          >
                            {item.title}
                          </small>
                          <small
                            className={
                              +item.total_message_unread
                                ? "text-warning fw-bolder"
                                : "text-muted truncate"
                            }
                          >
                            {+item.new_message
                              ? `${item.new_message} New Message!`
                              : item.message}
                          </small>
                        </div>
                      </div>

                      <small className="text-muted fw-bold">
                        <Moment utc fromNow>
                          {item.updated_at}
                        </Moment>
                      </small>
                    </div>
                    <div className="spacer">
                      <span></span>
                    </div>
                  </div>
                ))}
              </ScrollBar>
            ) : (
              <NothingToShow text={loading ? "Loading..." : "No Message"} />
            )}
          </Tab>

          {/* Archive Messages */}
          <Tab eventKey="2" title="Archive">
            <Card className="box-alert bordered">
              <Card.Body>
                <i className="las la-info-circle"></i>
                The archive chat feature allows you to hide an individual or
                group chat from your chats list.
              </Card.Body>
            </Card>
            {deactiveTickets.length ? (
              <ScrollBar style={{ height: `${mainCardHeight - 250}px` }}>
                {deactiveTickets.map((item) => (
                  <div className="item-box" key={item.id}>
                    <div
                      className={`item ${
                        selectedTicket && item.id === selectedTicket.id
                          ? "active"
                          : ""
                      }`}
                      key={item.id}
                      onClick={() => setSelectedTicket(item)}
                    >
                      <div>
                        <img
                          src={User}
                          alt="user-img"
                          className="rounded-full"
                        />
                        <div>
                          <small
                            className={
                              +item.total_message_unread
                                ? "text-black fw-bolder"
                                : ""
                            }
                          >
                            {item.title}
                          </small>
                          <small
                            className={
                              +item.total_message_unread
                                ? "text-warning fw-bolder"
                                : "text-muted truncate"
                            }
                          >
                            {+item.new_message
                              ? `${item.new_message} New Message!`
                              : item.message}
                          </small>
                        </div>
                      </div>

                      <small className="text-muted fw-bold">
                        <Moment utc fromNow>
                          {item.updated_at}
                        </Moment>
                      </small>
                    </div>
                    <div className="spacer">
                      <span></span>
                    </div>
                  </div>
                ))}
              </ScrollBar>
            ) : (
              <NothingToShow text={loading ? "Loading..." : "No Message"} />
            )}
          </Tab>
        </Tabs>
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

TicketList.propTypes = {
  selectedTicket: PropTypes.object.isRequired,
  setSelectedTicket: PropTypes.func.isRequired,
  mainCardHeight: PropTypes.number.isRequired,
};

export default TicketList;
